import { useState } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Modal } from '@iwoca/orion';

import { useGetMicroLoanOfferViewData } from './useGetMicroLoanOfferViewData';

export const MicroLoanOfferBanner = ({
    offerId
}: {
    offerId: NonNullable<TFormalOffer['offer_id']>;
}) => {
    const { isGrowthMicroLoan, isRegressedMicroLoan } =
        useGetMicroLoanOfferViewData(offerId);
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (isGrowthMicroLoan) {
        return (
            <p className="text-s font-med">
                <span className="text-xl">🎉 </span>Sie haben gute Fortschritte
                gemacht. Sie erhalten ein besseres Angebot und kommen dem vollen
                Zugang zu unserem Flexi Kredit näher.
            </p>
        );
    }
    if (isRegressedMicroLoan) {
        return (
            <p className="mx-xl text-left text-s font-med max-sm:m-m">
                <span className="text-xl">🕞</span> Für ein erweitertes Angebot
                reicht es aktuell noch nicht ganz.{' '}
                <span className="font-reg">
                    Bleiben Sie dran - mit gutem Rückzahlungsverhalten kommen
                    Sie dem Flexi Kredit Schritt für Schritt näher.
                </span>
            </p>
        );
    }
    return (
        <>
            <p className="text-s font-med">
                Wir konnten Ihre aktuelle Kreditanfrage nicht in vollem Umfang
                genehmigen.{' '}
                <Button
                    variant="tertiary"
                    className="p-0 text-s font-med text-structure-100 underline hover:bg-transparent"
                    onClick={() => {
                        tracking.ampli.creditBuilderBannerLearnMoreClicked({
                            offer_id: offerId
                        });
                        tracking.ampli.creditBuilderModalOpened();
                        setIsModalOpen(true);
                    }}
                >
                    Verbessern Sie jetzt Ihre Bonität.
                </Button>
            </p>
            <Modal
                size="large"
                headerBar
                closeIcon
                isOpen={isModalOpen}
                onClose={() => {
                    tracking.ampli.creditBuilderModalClosed();
                    setIsModalOpen(false);
                }}
                title={'🚀 Steigern Sie jetzt Ihre Bonitätsbeurteilung'}
                className="z-100 absolute"
            >
                <div>
                    <p className="font-reg">
                        Auch wenn wir Ihre aktuelle Kreditanfrage nicht in
                        vollem Umfang genehmigen können, möchten wir Sie dabei
                        unterstützen, Ihre finanzielle Zukunft zu stärken. Unser
                        Ziel ist es, Sie Schritt für Schritt auf diesem Weg zu
                        begleiten. Mit einem kleinen, überschaubaren Kredit
                        können Sie Ihre Bonitätsbeurteilung verbessern.
                    </p>

                    <h4>Vertrauen aufbauen – Schritt für Schritt</h4>

                    <p className="font-reg">
                        Wir wissen, dass jedes Unternehmen einmal klein anfängt
                        – und dass gerade in herausfordernden Zeiten
                        Unterstützung besonders wichtig ist. Vor allem bei
                        kleinen Unternehmen spiegeln klassische
                        Bonitätsbewertungen nicht immer das gesamte Potenzial
                        und die individuellen Stärken wider. <br /> <br />
                        Anstatt Kreditanfragen abzulehnen, möchten wir gezielt
                        unterstützen. Mit einem kurzfristigen Kredit geben wir
                        Ihnen die Möglichkeit, durch regelmäßige Rückzahlungen
                        Vertrauen aufzubauen und Ihre finanzielle
                        Verlässlichkeit zu demonstrieren. <br /> <br />
                        Diese Rückzahlungen stärken nicht nur Ihr Kreditprofil,
                        sondern werden auch bei zukünftigen Kreditentscheidungen
                        berücksichtigt. So können sich mit der Zeit bessere
                        Konditionen und höhere Kreditbeträge ergeben – ein
                        wichtiger Schritt in Richtung nachhaltiges Wachstum und
                        eine starke Partnerschaft.
                    </p>
                </div>
            </Modal>
        </>
    );
};
